import React from "react";
import { VatSectionData } from "../../data/sections/VatSectionData";

const VAT = ({ country }) => {
  const fetchVATData = country
    ? VatSectionData.countries.find(
        (c) =>
          c.country.replace(/\s+/g, "-").toLowerCase() ===
          country.replace(/\s+/g, "-").toLowerCase()
      )
    : null;

  if (!fetchVATData) {
    return (
      <div className="vat-section">
        <p className="error-message">
          Country not found or VAT data is unavailable.
        </p>
      </div>
    );
  }

  const { details } = fetchVATData;

  return (
    <div className="vat-section">
      <h3>VAT</h3>
      {Object.entries(details).map(([key, value], index) => (
        <DynamicRenderer key={index} title={key} data={value} />
      ))}
    </div>
  );
};

// Recursive renderer for dynamic data
const DynamicRenderer = ({ title, data }) => {
  return (
    <div className="dynamic-section">
      <h6>{formatKey(title)}</h6>
      {typeof data === "object" && !Array.isArray(data) ? (
        Object.entries(data).map(([key, value], idx) => (
          <div key={idx} className="nested-section">
            {typeof value === "object" && !Array.isArray(value) ? (
              <DynamicRenderer title={key} data={value} />
            ) : (
              <p>
                <span>{formatKey(key)}:</span> {formatValue(value)}
              </p>
            )}
          </div>
        ))
      ) : (
        <p>{formatValue(data)}</p>
      )}
    </div>
  );
};

// Utility function to format keys
const formatKey = (key) => {
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

// Utility function to format values
const formatValue = (value) => {
  if (Array.isArray(value)) {
    return (
      <ul>
        {value.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    );
  }
  return value;
};

export default VAT;
